document.addEventListener("DOMContentLoaded", function () {
  // Check if we're on a page with sticky component
  const stickyComponent = document.querySelector(".sticky-btn-atc");
  const mainProductForm = document.querySelector(
    'form[data-type="add-to-cart-form"]'
  );

  if (!stickyComponent || !mainProductForm) {
    return; // Exit if sticky component not found
  }

  const mainAddToCartBtn = stickyComponent.querySelector('button[name="add"]');

  // Function to generate unique ID
  function generateUniqueId() {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }

  // Function to get all addon selections from main page (updated for new system)
  function getMainPageAddonSelections() {
    // Check if the new multi-group addon system exists
    if (!window.addonGroupsNew) {
      return []; // No new addon system
    }

    // Get fresh selections from current state
    const currentSelections = [];
    window.addonGroupsNew.forEach((groupData, groupIndex) => {
      if (groupData.type === "drawer") {
        // Drawer mode - multiple categories
        Object.entries(groupData.categorySelections || {}).forEach(
          ([categoryIndex, selection]) => {
            if (selection.variantId) {
              // Find the addon card to get full details
              const panel = groupData.overlay.querySelector(
                `.category-tab-panel[data-category-index="${categoryIndex}"]`
              );
              const addonCard = panel
                ?.querySelector(`input[value="${selection.variantId}"]`)
                ?.closest(".addon-card-new");

              if (addonCard) {
                const addonTitle =
                  addonCard.querySelector(".addon-title-new")?.textContent ||
                  "Add-on";
                const addonImage =
                  addonCard.querySelector(".addon-image-new img")?.src || "";
                const addonPriceElement =
                  addonCard.querySelector(".addon-price-new");
                const addonComparePriceElement =
                  addonCard.querySelector(".old-price-new");

                let addonPriceFormatted = "£0";
                let addonComparePrice = 0;

                if (addonPriceElement) {
                  addonPriceFormatted = addonPriceElement.textContent.trim();
                } else {
                  // Fallback: format price from stored value
                  addonPriceFormatted = `£${(selection.price / 100).toFixed(
                    2
                  )}`;
                }

                // Get compare price if exists and is visible
                if (
                  addonComparePriceElement &&
                  addonComparePriceElement.style.display !== "none"
                ) {
                  const comparePriceText =
                    addonComparePriceElement.textContent.trim();
                  const comparePriceMatch =
                    comparePriceText.match(/[\d,]+\.?\d*/);
                  if (comparePriceMatch) {
                    addonComparePrice = parseFloat(
                      comparePriceMatch[0].replace(/,/g, "")
                    );
                  }
                }

                // Get addon variant name and option type
                let variantName = "";
                let variantOptionName = "Size";
                const variantIds = addonCard.dataset.variantIds
                  ? addonCard.dataset.variantIds.split(",")
                  : [];
                const variantTitles = addonCard.dataset.addonVariants
                  ? addonCard.dataset.addonVariants.split(",")
                  : [];
                const variantIndex = variantIds.indexOf(
                  String(selection.variantId)
                );
                if (variantIndex !== -1 && variantTitles[variantIndex]) {
                  // Extract variant value (before the "/")
                  const extractedName = variantTitles[variantIndex]
                    .split("/")[0]
                    .trim();

                  // Get the variant option name
                  const optionName = addonCard.dataset.variantOptionName || "Size";

                  // Filter out irrelevant variants
                  const irrelevantValues = ["Default Title", "Yes Please", "No Thanks", "Yes", "No"];
                  const irrelevantOptionNames = ["Title"];

                  if (!irrelevantValues.includes(extractedName) && !irrelevantOptionNames.includes(optionName)) {
                    variantName = extractedName;
                    variantOptionName = optionName;
                    // Normalize "Mattress Sizes" to "Size"
                    if (variantOptionName === "Mattress Sizes") {
                      variantOptionName = "Size";
                    }
                  }
                }

                currentSelections.push({
                  variantId: selection.variantId,
                  price: selection.price,
                  comparePrice: addonComparePrice,
                  variantName: variantName,
                  variantOptionName: variantOptionName,
                  title: addonTitle,
                  image: addonImage,
                  priceFormatted: addonPriceFormatted,
                  groupIndex: groupIndex,
                  categoryIndex: parseInt(categoryIndex),
                  categoryTitle: selection.categoryTitle,
                });
              }
            }
          }
        );
      } else if (groupData.type === "simple") {
        // Simple mode - checkbox or radio
        groupData.selectedVariants.forEach((variant) => {
          // Try to find the option element for additional details
          const option = groupData.container
            .querySelector(`input[data-variant-id="${variant.variantId}"]`)
            ?.closest(".simple-addon-option-new");

          let addonTitle = variant.title || "Add-on";
          let addonImage = "";
          let addonPriceFormatted = `£${(variant.price / 100).toFixed(2)}`;
          let addonComparePrice = 0;
          let addonVariantName = "";
          let addonVariantOptionName = "Size";

          // If we can find the option element, get details from DOM
          if (option) {
            const titleElement = option.querySelector(
              ".simple-addon-title-new"
            );
            const imageElement = option.querySelector(
              ".simple-addon-image-new img"
            );
            const priceElement = option.querySelector(
              ".simple-addon-price-new"
            );
            const comparePriceElement = option.querySelector(
              ".simple-old-price-new"
            );

            if (titleElement) {
              addonTitle = titleElement.textContent.trim();
            }
            if (imageElement) {
              addonImage = imageElement.src;
            }
            if (priceElement && priceElement.textContent.trim()) {
              addonPriceFormatted = priceElement.textContent.trim();
            }

            // Get compare price if exists and is visible
            if (
              comparePriceElement &&
              comparePriceElement.style.display !== "none"
            ) {
              const comparePriceText = comparePriceElement.textContent.trim();
              const comparePriceMatch = comparePriceText.match(/[\d,]+\.?\d*/);
              if (comparePriceMatch) {
                addonComparePrice = parseFloat(
                  comparePriceMatch[0].replace(/,/g, "")
                );
              }
            }

            // Get addon variant name and option type
            const variantIds = option.dataset.variantIds
              ? option.dataset.variantIds.split(",")
              : [];
            const variantTitles = option.dataset.addonVariants
              ? option.dataset.addonVariants.split(",")
              : [];
            const variantIndex = variantIds.indexOf(String(variant.variantId));
            if (variantIndex !== -1 && variantTitles[variantIndex]) {
              // Extract variant value (before the "/")
              const extractedName = variantTitles[variantIndex]
                .split("/")[0]
                .trim();

              // Get the variant option name
              const optionName = option.dataset.variantOptionName || "Size";

              // Filter out irrelevant variants
              const irrelevantValues = ["Default Title", "Yes Please", "No Thanks", "Yes", "No"];
              const irrelevantOptionNames = ["Title"];

              if (!irrelevantValues.includes(extractedName) && !irrelevantOptionNames.includes(optionName)) {
                addonVariantName = extractedName;
                addonVariantOptionName = optionName;
                // Normalize "Mattress Sizes" to "Size"
                if (addonVariantOptionName === "Mattress Sizes") {
                  addonVariantOptionName = "Size";
                }
              }
            }
          }

          currentSelections.push({
            variantId: variant.variantId,
            price: variant.price,
            comparePrice: addonComparePrice,
            variantName: addonVariantName,
            variantOptionName: addonVariantOptionName,
            title: addonTitle,
            image: addonImage,
            priceFormatted: addonPriceFormatted,
            groupIndex: groupIndex,
            categoryIndex: null,
            categoryTitle: null,
          });
        });
      }
    });

    return currentSelections;
  }

  // Fallback function for old system compatibility
  function getLegacyAddonSelection() {
    // Check if main page has addon drawer and a selection is made (old system)
    const addonTrigger = document.querySelector(".drawer-trigger");

    if (!addonTrigger) {
      return null; // No addon system on this page
    }

    // Check if addon trigger shows a selection
    const hasSelection = addonTrigger.classList.contains("has-selection");

    if (!hasSelection) {
      return null; // No addon selected
    }

    // Try to get the selected addon from the addon drawer script's global variables
    if (window.selectedAddonVariantId && window.selectedAddonPrice) {
      // Find the addon card that matches the selected variant ID to get full details
      const selectedAddonCard = document
        .querySelector(`input[value="${window.selectedAddonVariantId}"]`)
        ?.closest(".addon-card, .simple-addon-option");

      if (selectedAddonCard) {
        const addonTitle =
          selectedAddonCard.querySelector(".addon-title, .simple-addon-title")
            ?.textContent || "Add-on";
        const addonImage =
          selectedAddonCard.querySelector(
            ".addon-image img, .simple-addon-image img"
          )?.src || "";
        const addonPrice =
          selectedAddonCard.querySelector(".addon-price, .simple-addon-price")
            ?.textContent || "";

        return {
          variantId: window.selectedAddonVariantId,
          price: window.selectedAddonPrice,
          title: addonTitle,
          image: addonImage,
          priceFormatted: addonPrice,
          groupIndex: 0,
        };
      }

      // Fallback: try to get info from the trigger's displayed content
      const selectedProductInfo = addonTrigger.querySelector(
        ".selected-product-info"
      );
      if (selectedProductInfo) {
        const titleElement = selectedProductInfo.querySelector(
          ".selected-product-title"
        );
        const priceElement = selectedProductInfo.querySelector(
          ".selected-product-price"
        );
        const imageElement = selectedProductInfo.querySelector(
          ".selected-product-image img"
        );

        if (titleElement && priceElement) {
          return {
            variantId: window.selectedAddonVariantId,
            price: window.selectedAddonPrice,
            title: titleElement.textContent,
            image: imageElement?.src || "",
            priceFormatted: priceElement.textContent,
            groupIndex: 0,
          };
        }
      }

      // Basic fallback with just variant ID and price
      return {
        variantId: window.selectedAddonVariantId,
        price: window.selectedAddonPrice,
        title: "Add-on",
        image: "",
        priceFormatted: `£${(window.selectedAddonPrice / 100).toFixed(2)}`,
        groupIndex: 0,
      };
    }

    return null;
  }

  function getSelectedVariantTitle() {
    const selectedRadio = document.querySelector(
      'input[name*="Size"]:checked, input[name*="options"]:checked'
    );
    if (selectedRadio) {
      return selectedRadio.value.split("/")[0].trim();
    }

    const selectedDropdown = document.querySelector(
      'select[name*="Size"], select[name*="options"]'
    );
    if (selectedDropdown && selectedDropdown.value) {
      const selectedOption = selectedDropdown.querySelector(
        `option[value="${selectedDropdown.value}"]`
      );
      if (selectedOption && selectedOption.dataset.variantTitle) {
        return selectedOption.dataset.variantTitle.split("/")[0].trim();
      }
      return selectedDropdown.options[selectedDropdown.selectedIndex].text
        .split("/")[0]
        .trim();
    }

    return null;
  }

  function showSuccessPopup(itemsAdded, mainVariantId, addonSelections = []) {
    const popupHTML = `
      <div class="success-popup-overlay">
        <div class="success-popup">
          <div class="success-popup-header">
            <div class="success-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" fill="#22c55e"/>
                <path d="m9 12 2 2 4-4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3>Added to Cart!</h3>
            <button class="success-popup-close">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
          <div class="success-popup-content">
            <div class="added-products" id="addedProductsList"></div>
          </div>
          <div class="success-popup-footer">
            <button class="continue-shopping-btn">Continue Shopping</button>
            <a class="view-cart-btn" href="/cart">View Cart</a>
            <a class="checkout-cart-btn" href="/checkout">Go To Checkout</a>
          </div>
        </div>
      </div>
    `;

    const existingPopup = document.querySelector(".success-popup-overlay");
    if (existingPopup) {
      existingPopup.remove();
    }

    document.body.insertAdjacentHTML("beforeend", popupHTML);

    populateProductsList(itemsAdded, mainVariantId, addonSelections);

    setTimeout(() => {
      const popup = document.querySelector(".success-popup-overlay");
      if (popup) {
        popup.classList.add("active");
      }
    }, 100);

    setupPopupEventListeners();
  }

  function populateProductsList(
    itemsAdded,
    mainVariantId,
    addonSelections = []
  ) {
    const productsList = document.getElementById("addedProductsList");
    if (!productsList) return;

    try {
      const currentProductTitle =
        document
          .querySelector(".product-title, h1, .sticky-btn-atc h6")
          ?.textContent?.trim() || "Product";
      const currentProductImage =
        document.querySelector(".product-media img, .sticky-btn-atc img")
          ?.src || "";
      const currentProductPrice = document
        .querySelector("#ProductPrice")
        ?.textContent?.trim();

      let productsHTML = "";

      for (const item of itemsAdded) {
        if (item.id == mainVariantId) {
          productsHTML += `
            <div class="added-product-item">
              <div class="product-image">
                <img src="${currentProductImage}" alt="${currentProductTitle}" />
              </div>
              <div class="product-details">
                <h4>${currentProductTitle}</h4>
                <p class="product-variant"><span>Size:</span> ${
                  getSelectedVariantTitle() || ""
                }</p>
                <p class="product-quantity"><span>Qty:</span> ${
                  item.quantity
                }</p>
                <p class="product-price">${currentProductPrice}</p>
              </div>
            </div>
          `;
        } else {
          // Get category info from item properties
          const categoryIndex = item.properties?._addon_category_index;
          const categoryTitle = item.properties?._addon_category_title;

          // Find matching addon info - if we have a category index, match by both category and variant
          let addonInfo;
          if (categoryIndex !== undefined) {
            addonInfo = addonSelections.find(
              (addon) =>
                addon.variantId == item.id &&
                addon.categoryIndex == categoryIndex
            );
          } else {
            addonInfo = addonSelections.find(
              (addon) => addon.variantId == item.id
            );
          }

          if (addonInfo) {
            // Use category title from item properties if available, otherwise use from addonInfo
            const displayCategoryTitle =
              categoryTitle || addonInfo.categoryTitle;

            productsHTML += `
              <div class="added-product-item">
                <div class="product-image">
                  <img src="${addonInfo.image || currentProductImage}" alt="${
              addonInfo.title
            }" />
                </div>
                <div class="product-details">
                  <h4><span>Add-on${
                    displayCategoryTitle
                      ? " (" + displayCategoryTitle + ")"
                      : ""
                  }:</span> ${addonInfo.title}</h4>
                  ${
                    addonInfo.variantName
                      ? `<p class="product-variant"><span>${
                          addonInfo.variantOptionName || "Size"
                        }:</span> ${addonInfo.variantName}</p>`
                      : ""
                  }
                  <p class="product-quantity"><span>Qty:</span> ${
                    item.quantity
                  }</p>
                  <p class="product-price">${addonInfo.priceFormatted}</p>
                </div>
              </div>
            `;
          }
        }
      }

      productsList.innerHTML =
        productsHTML || "<p>Products added successfully!</p>";
    } catch (error) {
      console.error("Error populating products list:", error);
      productsList.innerHTML = "<p>Products added successfully!</p>";
    }
  }

  function setupPopupEventListeners() {
    const popup = document.querySelector(".success-popup-overlay");
    const closeBtn = document.querySelector(".success-popup-close");
    const continueBtn = document.querySelector(".continue-shopping-btn");

    function closePopup() {
      if (popup) {
        popup.classList.add("closing");
        popup.remove();
      }
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", closePopup);
    }

    if (continueBtn) {
      continueBtn.addEventListener("click", closePopup);
    }

    if (popup) {
      popup.addEventListener("click", function (e) {
        if (e.target === popup) {
          closePopup();
        }
      });
    }

    const escapeHandler = function (e) {
      if (e.key === "Escape" && popup) {
        closePopup();
        document.removeEventListener("keydown", escapeHandler);
      }
    };
    document.addEventListener("keydown", escapeHandler);
  }

  async function updateCartCounter() {
    try {
      const response = await fetch("/cart.json");
      if (response.ok) {
        const cartData = await response.json();
        const cartCountElement = document.querySelector(
          '.ajax-cart-count span[aria-hidden="true"]'
        );
        const cartCountVisuallyHidden = document.querySelector(
          ".ajax-cart-count .visually-hidden"
        );

        if (cartCountElement && cartData.item_count < 100) {
          cartCountElement.textContent = cartData.item_count;
        }

        if (cartCountVisuallyHidden) {
          cartCountVisuallyHidden.textContent = `Cart ${cartData.item_count}`;
        }

        const cartCountContainer = document.querySelector(".ajax-cart-count");
        if (cartCountContainer) {
          if (cartData.item_count > 0) {
            cartCountContainer.style.display = "block";
          } else {
            cartCountContainer.style.display = "none";
          }
        }

        // Also update .bigcounter for compatibility
        const bigCounter = document.querySelector(".bigcounter");
        if (bigCounter) {
          bigCounter.textContent = cartData.item_count;
        }
      }
    } catch (error) {
      console.error("Error updating cart counter:", error);
    }
  }

  async function handleStickyAddToCart(e) {
    e.preventDefault();

    if (!mainAddToCartBtn) return;

    const mainVariantId = document.querySelector('input[name="id"]').value;
    const quantityInput = document.querySelector('input[name="quantity"]');
    const formattedDeliveryDateInput = document.querySelector(
      'input[name="properties[Delivery Date]"]'
    );
    const flareDeliveryInput = document.querySelector(
      'input[name="properties[__flare]"]'
    );
    const flareDeliveryDateInput = document.querySelector(
      'input[name="properties[__flare_delivery_date]"]'
    );

    const quantity = quantityInput ? quantityInput.value : 1;
    const formattedDeliveryDate = formattedDeliveryDateInput
      ? formattedDeliveryDateInput.value
      : null;
    const flareDelivery = flareDeliveryInput ? flareDeliveryInput.value : null;
    const flareDeliveryDate = flareDeliveryDateInput
      ? flareDeliveryDateInput.value
      : null;

    // Get all addon selections from new multi-group system
    let addonSelections = getMainPageAddonSelections();

    // Fallback to legacy system if new system not found
    if (addonSelections.length === 0) {
      const legacySelection = getLegacyAddonSelection();
      if (legacySelection) {
        addonSelections = [legacySelection];
      }
    }

    mainAddToCartBtn.disabled = true;
    const loader = mainAddToCartBtn.querySelector(".ajax-loader");
    const cartTitle = mainAddToCartBtn.querySelector(".cart-title");

    if (loader) loader.style.display = "block";
    if (cartTitle) cartTitle.style.display = "none";

    try {
      const itemsToAdd = [];
      const uniqueId = generateUniqueId();

      const mainProductProperties = {
        _product_group_id: uniqueId,
        _is_upsell: addonSelections.length > 0 ? "true" : "false",
        _upsell_for: null,
        _upsell_to:
          addonSelections.length > 0
            ? addonSelections.map((a) => a.variantId).join(",")
            : null,
      };

      if (formattedDeliveryDate && flareDelivery && flareDeliveryDate) {
        mainProductProperties["Delivery Date"] = formattedDeliveryDate;
        mainProductProperties["__flare"] = flareDelivery;
        mainProductProperties["__flare_delivery_date"] = flareDeliveryDate;
      }

      // Add main product
      itemsToAdd.push({
        id: mainVariantId,
        quantity: parseInt(quantity),
        properties: mainProductProperties,
      });

      // Add selected addons
      addonSelections.forEach((addon) => {
        const addonProperties = {
          _product_group_id: uniqueId,
          _is_upsell: "true",
          _upsell_for: mainVariantId,
          _upsell_to: null,
          _addon_group_index: addon.groupIndex,
          _addon_category_index: addon.categoryIndex,
          _addon_category_title: addon.categoryTitle,
        };

        if (formattedDeliveryDate && flareDelivery && flareDeliveryDate) {
          addonProperties["Delivery Date"] = formattedDeliveryDate;
          addonProperties["__flare"] = flareDelivery;
          addonProperties["__flare_delivery_date"] = flareDeliveryDate;
        }

        itemsToAdd.push({
          id: addon.variantId,
          quantity: parseInt(quantity),
          properties: addonProperties,
        });
      });

      const response = await fetch("/cart/add.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: itemsToAdd,
        }),
      });

      if (response.ok) {
        const addedItems = await response.json();

        if (typeof window.refreshCart === "function") {
          window.refreshCart();
        } else {
          updateCartCounter();
        }

        // Try to refresh mini cart if it exists
        try {
          const cartSectionResponse = await fetch("/cart?view=ajax", {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          });

          if (cartSectionResponse.ok) {
            const cartSectionHTML = await cartSectionResponse.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(cartSectionHTML, "text/html");
            const newCartContent = doc.querySelector("#ajaxcart");
            const currentCartContent = document.querySelector("#ajaxcart");

            if (newCartContent && currentCartContent) {
              currentCartContent.innerHTML = newCartContent.innerHTML;

              // Remove empty class from mini cart
              const miniCart = document.querySelector(".mini-cart");
              if (miniCart && miniCart.classList.contains("is-empty")) {
                miniCart.classList.remove("is-empty");
              }
            }
          }
        } catch (cartRefreshError) {
          console.error(
            "Cart refresh failed, continuing with counter update only"
          );
        }

        document.dispatchEvent(new CustomEvent("cart:refresh"));
        document.dispatchEvent(new CustomEvent("cart:update"));

        showSuccessPopup(itemsToAdd, mainVariantId, addonSelections);

        setTimeout(() => {
          mainAddToCartBtn.disabled = false;
          if (loader) loader.style.display = "none";
          if (cartTitle) cartTitle.style.display = "flex";
        }, 2000);
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to add to cart");
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
      if (cartTitle) cartTitle.style.display = "flex";
      if (cartTitle) cartTitle.textContent = "Error - Try Again";

      mainAddToCartBtn.disabled = false;
      if (loader) loader.style.display = "none";

      setTimeout(() => {
        if (cartTitle) cartTitle.style.display = "flex";
      }, 3000);
    }
  }

  // Function to update sticky addon counter
  function updateStickyAddonCounter(addonCount) {
    const counterContainer = document.querySelector(".sticky-addon-counter");
    const counterText = document.querySelector(".sticky-addon-count-text");

    if (!counterContainer || !counterText) return;

    if (addonCount > 0) {
      counterText.textContent = `(${addonCount} add-on${
        addonCount > 1 ? "s" : ""
      } selected)`;
      counterContainer.style.display = "block";
    } else {
      counterContainer.style.display = "none";
    }
  }

  // Function to update sticky price display
  function updateStickyPrice() {
    const stickyPriceElement = document.querySelector("#StickyProductPrice");
    const stickyComparePriceElement = document.querySelector(
      "#StickyComparePrice"
    );

    if (!stickyPriceElement) return;

    // Get main product price
    const mainPriceElement = document.querySelector("#ProductPrice");
    const mainComparePriceElement = document.querySelector("#ComparePrice");

    if (!mainPriceElement) return;

    // Extract numeric values from price strings
    const mainPriceText = mainPriceElement.textContent.trim();
    const mainPriceMatch = mainPriceText.match(/[\d,]+\.?\d*/);
    const mainPrice = mainPriceMatch
      ? parseFloat(mainPriceMatch[0].replace(/,/g, ""))
      : 0;

    let mainComparePrice = 0;
    if (mainComparePriceElement && mainComparePriceElement.textContent.trim()) {
      const mainComparePriceText = mainComparePriceElement.textContent.trim();
      const mainComparePriceMatch = mainComparePriceText.match(/[\d,]+\.?\d*/);
      mainComparePrice = mainComparePriceMatch
        ? parseFloat(mainComparePriceMatch[0].replace(/,/g, ""))
        : 0;
    }

    // Get all addon selections
    const addonSelections = getMainPageAddonSelections();

    // Update addon counter
    updateStickyAddonCounter(addonSelections.length);

    // Calculate total addon price and compare price
    let totalAddonPrice = 0;
    let totalAddonComparePrice = 0;
    addonSelections.forEach((addon) => {
      totalAddonPrice += addon.price / 100; // Convert from cents to pounds
      // Use compare price if available, otherwise use regular price
      if (addon.comparePrice && addon.comparePrice > 0) {
        totalAddonComparePrice += addon.comparePrice;
      } else {
        totalAddonComparePrice += addon.price / 100;
      }
    });

    // Calculate totals
    const totalPrice = mainPrice + totalAddonPrice;
    const totalComparePrice =
      mainComparePrice > 0 ? mainComparePrice + totalAddonComparePrice : 0;

    // Update sticky price
    stickyPriceElement.textContent = `£${totalPrice.toFixed(2)}`;

    // Update sticky compare price
    if (totalComparePrice > totalPrice) {
      if (stickyComparePriceElement) {
        stickyComparePriceElement.textContent = `£${totalComparePrice.toFixed(
          2
        )}`;
        stickyComparePriceElement.style.display = "";
      }
    } else {
      if (stickyComparePriceElement) {
        stickyComparePriceElement.style.display = "none";
      }
    }
  }

  // Function to setup price update listeners
  function setupPriceUpdateListeners() {
    // Listen for addon selection changes from the main addon system
    const observer = new MutationObserver(() => {
      updateStickyPrice();
    });

    // Observe changes to selected products display areas (drawer mode)
    const selectedDisplays = document.querySelectorAll(
      ".selected-addons-display-new"
    );
    selectedDisplays.forEach((display) => {
      observer.observe(display, {
        childList: true,
        subtree: true,
      });
    });

    // Listen for variant changes
    const variantSelectors = document.querySelectorAll(
      'input[name*="Size"], select[name*="Size"], input[name*="options"], select[name*="options"]'
    );
    variantSelectors.forEach((selector) => {
      selector.addEventListener("change", () => {
        setTimeout(updateStickyPrice, 100); // Small delay to let prices update
      });
    });

    // Listen for drawer mode addon selections (radio button clicks)
    document.addEventListener("change", (e) => {
      if (e.target.matches('input[type="radio"][data-category-index]')) {
        setTimeout(updateStickyPrice, 100);
      }
    });

    // Listen for simple mode addon selections (checkbox changes)
    document.addEventListener("change", (e) => {
      if (e.target.matches(".simple-addon-checkbox")) {
        setTimeout(updateStickyPrice, 100);
      }
    });

    // Listen for simple mode remove button clicks
    document.addEventListener("click", (e) => {
      if (e.target.closest(".simple-remove-btn-new")) {
        setTimeout(updateStickyPrice, 100);
      }
    });

    // Listen for drawer mode remove button clicks
    document.addEventListener("click", (e) => {
      if (e.target.closest(".remove-selected-product-new")) {
        setTimeout(updateStickyPrice, 100);
      }
    });

    // Listen for sticky price updated event from plugins.js (after variant change)
    document.addEventListener("stickyPriceUpdated", () => {
      // Small delay to let addon system update its selections
      setTimeout(updateStickyPrice, 150);
    });

    // Initial price update
    updateStickyPrice();
  }

  // Event Listeners
  if (mainProductForm) {
    mainProductForm.addEventListener("submit", handleStickyAddToCart);
  }

  if (mainAddToCartBtn) {
    mainAddToCartBtn.addEventListener("click", function (e) {
      if (mainProductForm) {
        e.preventDefault();
        handleStickyAddToCart(e);
      }
    });
  }

  // Setup price update listeners
  setupPriceUpdateListeners();
});
